<template>
  <div>
    <main class="main product-details-main">
      <PagePath
        :pathTitle1="'محصولات'"
        :pathTo1="'/products'"
        :pathTitle2="product != null ? product.title : ''"
        class="page-path-product-dtl"
      ></PagePath>
      <ProductContent v-model="product" />
   
      <section
        class="
          product-specifications-comments
          container
          bg-white
          text-right
          box-shaddow20
          border-radius15
          mb-5
          pb-2
        "
      >
        <!-- <div class="container"> -->

        <ul v-if="product != null" class="nav nav-tabs border-bottom py-4 px-1">
          <li
            v-if="product != null && product.description != null"
            :class="activeTab === 'review' ? 'active' : ''"
          >
            <a
              class="
                px-sm-3
                p-2
                m-1
                border-radius10
                text-color-444
                fontsize14
                font-weight-bold
                
              "
              data-toggle="tab"
              :class="activeTab==='review' ? 'active' : ''" @click="changeTab('review')"
            >
              نقد بررسی
            </a>
          </li>
          <li v-if="product != null && product.specifications != ''" :class="activeTab === 'specifications' ? 'active' : ''">
            <a
              class="
                px-sm-3
                p-2
                m-1
                border-radius10
                text-color-444
                fontsize14
                font-weight-bold
              "
              data-toggle="tab"
              :class="activeTab === 'specifications' ? 'active' : '' " @click="changeTab('specifications')"
            >
              مشخصات
            </a>
          </li>
          <li :class="activeTab === 'comments' ? 'active' : '' ">
            <a
              class="
                px-sm-3
                p-2
                m-1
                border-radius10
                text-color-444
                fontsize14
                font-weight-bold
              "
              data-toggle="tab"
              :class="activeTab === 'comments' ? 'active' : '' " @click="changeTab('comments')"
            >
              نظرات کاربران
            </a>
          </li>
        </ul>
        <ul v-else class="nav nav-tabs border-bottom py-4 px-1">
          <li :class="activeTab==='review' ? 'active' : ''" @click="changeTab('review')">
            <a
              class="
                px-sm-3
                p-2
                m-1
                border-radius10
                text-color-444
                fontsize14
                font-weight-bold
                
              "
              data-toggle="tab"
              href="#review"
            >
              نقد بررسی
            </a>
          </li>
        </ul>
        <div v-if="product != null" class="tab-content border-radius15">
               <ProductReview :activeTab="activeTab" :product="product"/>
          <ProductSpecifications :activeTab="activeTab" :product="product"/>
          <ProductComments :activeTab="activeTab" :product="product"/>
     
      
        </div>
        <div v-else class="tab-content border-radius15">
          <div id="review" class="tab-pane fade in active show">
            <p class="fontsize14 text-color-666 text-justify line-height2 p-3">
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="85%"></b-skeleton>
            </p>
          </div>
        </div>
        <!-- </div> -->
      </section>
      <SpecialProducts title="مشابه"></SpecialProducts>
    </main>
  </div>
</template>
<script>

import product from "@/parts/Front/components/productDetail/classes/product";
import ProductContent from "@/parts/Front/components/productDetail/ProductContent";
import ProductComments from "@/parts/Front/components/productDetail/ProductComments";
import ProductSpecifications from "@/parts/Front/components/productDetail/ProductSpecifications";
import ProductReview from "@/parts/Front/components/productDetail/ProductReview";
import ProductCongratulations from "@/parts/Front/components/productDetail/ProductCongratulations";
import config from '@/config'
import Swiper from "swiper/swiper-bundle.min";
import PagePath from "../components/PagePath";
import SpecialProducts from "../components/SpecialProducts";
export default {
  name: "ProductDetails",
  components: {
    PagePath,
    SpecialProducts,ProductComments,
    ProductContent,ProductSpecifications,ProductReview,ProductCongratulations,config
  },
  data() {
    return {
      url: 'front/products/',
      title: '',
      disabled: false,
      product: null,
      activeTab: null,
    }
  },
  methods: {
    
    changeTab(name) {
      // this.$store.commit('front/setProductActiveTab', name)
      this.activeTab = name
    },
    async getProduct(id) {
      this.disabled = true
      
    },
  },
  mounted() {
    // this.$store.dispatch('front/getProductDataFromServer', this.$route.params.id)
  
    

     
      
   
      
    

  
  },
  beforeCreate() {
    this.$store.dispatch("front/getProductDetailFromServer", this.$route.params.id)
  },
  watch:{
    productDetail(val){
      if(val!=null){
        this.product =new product(val,this);
        console.log(this.product)
           if (val.description != null) {
          this.activeTab = 'review'
        } else if (val.description == null && val.specifications != '') {
          this.activeTab = 'specifications'
        } else {
          this.activeTab = 'comments'
        }
      }
    }
  },
  computed:{
    productDetail(){
      if(this.$store.getters["front/getProductDetail"]==null){
        return null
      }else{
        return this.$store.getters["front/getProductDetail"];
      }
    },
    relatedProducts(){
       if(this.$store.getters["front/getProductDetail"]==null){
        return null
      }else{
        return this.$store.getters["front/getProductDetail"].relatedProducts;
      }
    }
  },
   metaInfo() {
    return {
      title: this.product ? config.title + ` - ${this.product.title}` : config.title,
      meta: [
        {
          name: 'description',
          content: this.product ? this.product.short_description : false
        },
        {property: 'og:title', content: this.product ? this.product.title : false},
        {name: 'robots', content: 'index,follow'}
      ]
    }
  }
};





</script>

<style scoped>
/****** <<<<<< start product-details page >>>>>>>> ******/

.product-details-main {
  min-height: 500px;
}
.product-details {
  /*border-radius: 0 0 20px 20px;*/
  display: grid;
  grid-template-columns: 415px 700px;
}

.color-choose-img > div {
  min-width: 300px;
}

.product-details-l-img {
  width: 300px;
  height: 400px;
  background-image: radial-gradient(#fafafa, #f4f4f4, #e1e1e1);
  overflow: hidden;
  text-align: center;
  /*padding-left: 15px;*/
}
.product-details-l-img img {
  max-width: 100%;
  max-height: 100%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.product-details-color-choose button {
  width: 80px;
  height: 94px;
  text-align: center;
  margin-left: 10px;
  /*box-sizing: border-box !important;*/
  transition: 0.3s;
}
.product-details-color-choose button:hover {
  border: 1px solid var(--color-theme);
}
.product-details-color-choose button:hover .product-color-choose-bottom {
  background-color: var(--color-theme);
  color: white !important;
}
.product-color-choose-img {
  height: 65px;
  width: 100%;
  background-image: radial-gradient(#fafafa, #f4f4f4, #e1e1e1);
}
.product-color-choose-img img {
  max-width: 100%;
  max-height: 100%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.product-color-choose-bottom {
  background-color: #dedede;
}
.product-details-cart-btn {
  width: 300px;
  transition: 0.3s;
}
.product-details-cart-btn:hover {
  background-color: var(--color-theme2);
}
.services {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}
.product-details-size-choose .select {
  width: 145px;
  height: 35px;
  margin-left: 10px;
}
.product-details-size-choose > button {
  width: 145px;
  height: 35px;
}
.product-specifications-comments li a:hover {
  color: var(--color-444);
}
.product-specifications-comments li a.active {
  color: var(--color-theme) !important;
  background-color: var(--color-themeOp);
}
.product-specifications-comments li a.active > svg > path {
  fill: var(--color-theme) !important;
}
/*.specifications-grid{*/
/*    display: grid;*/
/*    grid-template-columns: 1fr 8fr;*/
/*    grid-gap: 7px;*/
/*}*/
.response-register .response-register-grid {
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-gap: 15px;
}
.response-register form textarea {
  height: 125px;
}
.color-choose-img {
  max-width: 450px;
  overflow-x: auto;
  scrollbar-color: var(--color-theme) var(--color-theme2);
  scrollbsr-width: thin;
}
.color-choose-img button {
  flex-shrink: 0;
}
.product-details-l-img
  .swiper-container-horizontal
  > .swiper-pagination-bullets,
.product-details-l-img .swiper-pagination-custom,
.product-details-l-img .swiper-pagination-fraction {
  bottom: 0 !important;
}
.product-details-l-img .swiper-pagination-bullet-active {
  background: var(--swiper-pagination-color, var(--color-theme)) !important;
}
.product-details-l-img
  .swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 0 2px;
}

/****** <<<<<< End product-details page >>>>>>>> ******/

@media screen and (max-width: 1199px) {
  .product-details {
    grid-template-columns: 415px 500px;
  }
}
@media screen and (max-width: 991px) {
  .product-details {
    grid-template-columns: 1fr;
  }
  .services a p {
    display: none;
  }
  .product-list-main-grid {
    grid-template-columns: 1fr;
  }
  .products-list-grid {
    grid-gap: 15px;
  }
}
@media screen and (max-width: 576px) {
  .product-details-cart-btn {
    position: fixed;
    bottom: 5px;
    right: 0;
    left: 0;
    z-index: 99;
    width: 95%;
    margin: auto auto;
    padding: 13px 0;
  }
  .product-details-size-choose.text-right {
    text-align: center !important;
  }
  .services.d-flex {
    display: grid !important;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 5px;
  }

  .services-img {
    width: 30px;
    height: 20px;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .services-img img {
    max-width: 100%;
    max-height: 100%;
  }
  .services a h6 {
    font-size: 11px !important;
  }
  .response-register .response-register-grid {
    display: block;
  }
  .product-details-title h5 {
    font-size: 16px;
  }
  .product-details-title h6 {
    display: none;
  }
}
@media screen and (max-width: 400px) {
  .product-details-size-choose .select,
  .product-details-size-choose > button {
    width: 46%;
  }
}
</style>
